export default __webpack_public_path__ + "static/media/13.a9929cd2.jpg";